import React, { useEffect, useState } from 'react'
import PageHeadSection from '../admin/components/PageHeadSection'
import ItemsRequestsApp, { itemsRequestCategories, itemsReuestStatusTypes } from './ItemsRequestsApp'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import DynamicForm, { IDynamicForm, IDynamicFormElement } from '../../components/Form/DynamicForm'
import GenerateForm from '../../components/Form/GenerateForm'
import { useDispatch } from 'react-redux'
import { addNewForm, createOrUpdateElementData } from '../../components/Form/formsSlice'
import UsersApp from '../user/UsersApp'
import ProjectsApp from '../projects/ProjectsApp'
import { IRequestedItem, ItemsRequestModel } from '.'
import SelectRequestedItems from './SelectRequestedItems2'
import { LoadingButton } from '@mui/lab'
import GenerateIcon, { IconTypes } from '../../components/GenerateIcon'
import { handleRequestError } from '../../services/api'
import { IAxiosDefaultDataObject } from '../../config'
import AlertElement from '../../components/AlertElement'
import SelectTransactionActions from '../transactions/SelectTransactionActions'
import SelectTransactionType from '../transactions/SelectTransactionType'
import RequestDesignation from './RequestDesignation'
import windowLocationRedirect from '../redirect'
import { useReturnCurrentUser } from '../user/userSlice'
import { useMatch, useNavigate } from 'react-router-dom'
import { Checkbox, FormControlLabel } from '@mui/material'

interface INewRequestProps {
    hidePageHeadSection?: boolean,
    noFormSectionWrap?: boolean,
    noRequestedItemsWrap?: boolean,
    staffPage?: boolean,
}

export default function NewRequest(props: INewRequestProps) {

    // useEffect(() => {
    //     const handleBeforeUnload = (e: BeforeUnloadEvent) => {
    //     e.preventDefault();
    //     e.returnValue = ''; // Show native confirm dialog
    //     };
    //     window.addEventListener("beforeunload", handleBeforeUnload);
    //     return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    // }, []);

    const dispatch = useDispatch()
    const isCurrentPageAdminPanel = useMatch('/panel/*')

    const navigate = useNavigate()

    const { hidePageHeadSection, noFormSectionWrap, noRequestedItemsWrap, staffPage } = props

    const [items, setItems] = useState<IRequestedItem[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const itemsRequestApp = new ItemsRequestsApp()
    const usersApp = new UsersApp()
    const projectsApp = new ProjectsApp()

    const currentUser = useReturnCurrentUser()

    const prefix = itemsRequestApp.elemPrefix

    const [errors, setErrors] = useState<string[]>([])
    const [requestErrors, setRequestErrors] = useState<string[]>([])

    const elementsData = DynamicForm.useReturnAllFormsData()
    const singleElemDataValue = (name: string) => DynamicForm.returnSingleFormElementData(prefix + name, elementsData).value

    const [actionType, setActionType] = useState<string>("")
    const [designationType, setDesignationType] = useState<string>("")

    const requestTitle = singleElemDataValue("title")
    const requestedBy = singleElemDataValue("requested_by")
    const projectId = singleElemDataValue("project_id")
    const note = singleElemDataValue("note")
    const category = singleElemDataValue("category")
    const startDate = singleElemDataValue("start_date")
    const endDate = singleElemDataValue("end_date")

    const [warehouseId, setWarehouseId] = useState<number | null>(null)
    const [sectionId, setSectionId] = useState<number | null>(null)
    const [locationId, setLocationId] = useState<number | null>(null)
    const [userId, setUserId] = useState<number | null>(null)
    const [sendEmailEnabled, setSendEmailEnabled] = useState<boolean>(true)

    const [successMessage, setSuccessMessage] = useState<string>("")

    /**
     * Steps
     */
    const [availableSteps, setAvailableSteps] = useState<string[]>([
        "action_type"
    ])
    const [activateStep, setActiveStep] = useState<string>("action_type")

    const [stepLineLeft, setStepLineLeft] = useState<number>(0)
    const [stepLineWidth, setStepLineWidth] = useState<number>(0)

    interface IStep {
        name: string,
        icon: IconTypes,
        title: string,
        component: () => JSX.Element
    }

    /**
     * Update Available step
     */
    const addAvailableStep = (step: string) => {
        setAvailableSteps(prev =>
          prev.includes(step) ? prev : [...prev, step]
        )
    }

    const removeAvailableStep = (step: string) => {
        setAvailableSteps(prev =>
          prev.filter(s => s !== step)
        )
    }

    const hasStep = (step: string): boolean => {
        return availableSteps.includes(step)
    }

    /**
     * Validate form
     */
    const validateForm = () => {

        let errors: string[] = []

        if (!requestedBy){
            errors.push("Requested by is required.")
        }

        if (!category){
            errors.push("Category is required.")
        }

        // if (!projectId){
        //     errors.push("Project is required.")
        // }
     
        return errors
    }
    
    /**
     * Form
     */
    let formElements: IDynamicFormElement[] = []

    formElements.push({
        id: prefix + "title",
        xs: 12,
        type: "TextField",
        label: "Request Title",
        fullWidth: true,
        placeholder: "Optional title"
    })

    formElements.push( {
        id: prefix + "requested_by",
        xs: 4,
        type: "DynamicModelSelect",
        label: "Requested by",
        fullWidth: true,
        appClass: usersApp,
        selectLabel: "Select user",
        gridColumns: usersApp.gridDataColumns,
        // disabled: currentUser.is_superuser ? false : true,
        disabled: staffPage ? true : false,
    })

    formElements.push({
        id: prefix + "project_id",
        xs: 4,
        type: "DynamicModelSelect",
        label: "Project",
        fullWidth: true,
        appClass: projectsApp,
        selectLabel: "Select Project",
        gridColumns: projectsApp.gridDataColumns
    })

    formElements.push( {
        id: prefix + "category",
        xs: 4,
        type: "Select",
        label: "Category",
        fullWidth: true,
        displayForItem: true,
        addNoneItem: true,
        items: itemsRequestCategories
    })

    formElements.push({
        id: prefix + "start_date",
        xs: 6,
        type: "Date",
        label: "Taken On",
        fullWidth: true,
    })

    formElements.push({
        id: prefix + "end_date",
        xs: 6,
        type: "Date",
        label: "Return by",
        fullWidth: true,
    })

    formElements.push({
        id: prefix + "note",
        xs: 12,
        type: "TextField",
        label: "Note",
        fullWidth: true,
        multiline: true,
        maxRows: 4,
        minRows: 4
    })

    const form: IDynamicForm = {
        name: "new_items_request_form",
        elements: formElements
    }

    /**
     * Create form elem data
     */
    const createFormElemData = () => {
        form.elements.map((elem) => dispatch(createOrUpdateElementData({
            name: elem.id,
            value: ""
        })))
    }

    /**
     * Register form
     */
    useEffect(() => {

        dispatch(addNewForm({
            name: form.name,
            elements: form.elements
        }))

        createFormElemData()

    }, [])

    /**
     * If staff
     */
    useEffect(() => {
        if (!currentUser.is_superuser){
            dispatch(createOrUpdateElementData({
                name: prefix + "requested_by",
                value: currentUser.id
            }))
        }

        if (currentUser.is_superuser){
            if (!isCurrentPageAdminPanel){
                navigate("/panel/item_requests/new")
            }
        }

    }, [currentUser])

    /**
     * Update errors
     */
    useEffect(() => {
        
        let errors: string[] = []

        if (validateForm().length > 0){
            errors = [
                ...validateForm()
            ]
        }

        if (items.length === 0){
            errors.push("You must add at least one item to create a request.")
        }else{

            items.map((item) => {
                if (item.allocations.length === 0){
                    errors.push(`Update '${item.item.title}' quantity. Allocations are missing`)
                }
            })

        }

        setErrors(errors)

    }, [elementsData, items])


    /**
     * Handle submit
     */
    const handleSubmit = () => {
        if (errors.length > 0){
            return;
        }

        setErrors([])
        setRequestErrors([])

        setLoading(true)

        let data: IAxiosDefaultDataObject = {
            requested_by: requestedBy,
            project_id: projectId,
            note: note,
            title: requestTitle,
            items: items,
            designation_type: designationType,
            action_type: actionType,
            destination_warehouse: warehouseId,
            destination_section: sectionId,
            destination_location: locationId,
            destination_user: userId,
            category: category,
            start_date: startDate ? new Date(startDate).toISOString().split("T")[0] : null,
            return_by_date: endDate ? new Date(endDate).toISOString().split("T")[0] : null,
            send_email: sendEmailEnabled,
        }

        itemsRequestApp.createNewInstance(data)
            .then(response => {

                const { data } = response

                const request: ItemsRequestModel = data.request

                setSuccessMessage(data.message)
                setActiveStep("final")
                setLoading(false)

                setAvailableSteps([
                    "final"
                ])

                setErrors([])

                if (staffPage){
                    setTimeout(() => windowLocationRedirect("requests/" + request.request_number), 2000)
                }else{
                    setTimeout(() => windowLocationRedirect("panel/item_requests/view/" + request.request_number), 2000)
                }

            })
            .catch(error => {
  
                if (error.response.data.errors){
                    setRequestErrors(error.response.data.errors)
                }else{
                    handleRequestError(error, dispatch)
                }

                setLoading(false)

            })

    }

    /**
     * Success Message
     */
    const renderSuccessMessage = () => {

        return(
            <SectionBoxContainer
                showTitle
                title="Completed"
            >
                <div className="request-items-success-message">
                    <AlertElement type="success" message={successMessage} />
                </div>
            </SectionBoxContainer>
        )
    }

    /**
     * Return create new request form
     */
    const renderCreateNewRequestForm = () => {
        return(
            <>
                <SectionBoxContainer 
                    showTitle
                    title="Request Details"
                    noWrap={noFormSectionWrap}
                >
                    <GenerateForm name={form.name} />

                    <FormControlLabel style={{ marginTop: 5 }} control={<Checkbox checked={sendEmailEnabled} onChange={(e) => setSendEmailEnabled(e.target.checked)} />} label="Notify admin by email" />

                    {errors.length > 0 || requestErrors.length > 0 ? (
                        <div className="errors-list-container">
                            <div className="content-of-errors-list-container">
                                
                                <div className="header-of-errors-list-container">
                                    <div className="content-of-header-of-errors-list-container">
                                        <GenerateIcon icon="error" />
                                        <h3>Unable to create the request:</h3>
                                    </div>
                                </div>

                                <div className="list-of-errors-list-container">
                                    {errors.map((error, index) => <p key={index}>{index + 1}. {error}</p>)}
                                    {requestErrors.map((error, index) => <p key={index}>{index + 1}. {error}</p>)}
                                </div>

                            </div>
                        </div>
                    ) : <></>}

                    <div className="action-buttons-of-section-box-admin-panel items-requests">
                        <div className="content-of-action-buttons-of-section-box-admin-panel">

                            <LoadingButton loading={loading} disabled={errors.length > 0 ? true : false} className="general-button admin-style light-button" color="success" variant="contained" onClick={() => handleSubmit()}>Create Request</LoadingButton>

                        </div>
                    </div>

                </SectionBoxContainer>

                <div className="requested-items-section-of-new-items-request-container">
                    <SelectRequestedItems items={items} setItems={(items) => setItems(items)} />
                </div>
            </>
        )
    }


    /**
     * Handle update action type
     */
    const updateTransactionType = (type: string) => {
        setActionType(type)
        setActiveStep("designation_type")
        addAvailableStep("designation_type")
    }

    /**
     * Handle update designation type
     */
    const handleUpdateDesignationType = (type: string) => {
        setDesignationType(type)
        setActiveStep("designation")
        addAvailableStep("designation")
    }

    /**
     * Render action type
     */
    const renderActionType = () => {
        return(
            <SectionBoxContainer
                showTitle
                title="Select request action type"
            >
                <SelectTransactionActions selectedType={actionType} handleSelectedType={updateTransactionType} useRequestsTypes={true} />
            </SectionBoxContainer>
        )
    }

    /**
     * Render designation type
     */
    const renderDesignationType = () => {
        return(
            <SectionBoxContainer
                showTitle
                title="Select request destination type"
            >
                <SelectTransactionType selectedType={designationType} selectedAction={actionType} handleSelectedType={handleUpdateDesignationType} useRequestsTypes={true} />
            </SectionBoxContainer>
        )
    }

    /**
     * Designtation Step
     */
    const designationStep = () => {
        return(
            <SectionBoxContainer
                showTitle
                title="Select request destination"
            >
                <RequestDesignation 
                    actionType={actionType}
                    designationType={designationType}
                    warehouseId={warehouseId}
                    sectionId={sectionId}
                    locationId={locationId}
                    userId={userId}
                    updateWarehouseId={(id) => setWarehouseId(id)}
                    updateSectionId={(id) => setSectionId(id)}
                    updateLocationId={(id) => setLocationId(id)}
                    updateUserId={(id) => setUserId(id)}
                />
            </SectionBoxContainer>
        )
    }

    const steps: IStep[] = [
        {
            name: "action_type",
            icon: "transfer",
            title: "Action Type",
            component: renderActionType
        },
        {
            name: "designation_type",
            icon: "folder",
            title: "Destination Type",
            component: renderDesignationType
        },
        {
            name: "designation",
            icon: "inventory",
            title: "Destination",
            component: designationStep
        },
        {
            name: "details",
            icon: "list",
            title: "Details",
            component: renderCreateNewRequestForm
        },
        {
            name: "final",
            icon: "success",
            title: "Final",
            component: renderSuccessMessage
        }
    ]

    useEffect(() => {
        if (activateStep){
            const elem = document.getElementById("step-" + activateStep)
            if (elem){
                setStepLineWidth(elem.clientWidth)
                setStepLineLeft(elem.offsetLeft)
            }
        }
    }, [activateStep])

    useEffect(() => {

        if (designationType === "warehouse"){
            if (warehouseId && sectionId){
                setActiveStep("details")
                addAvailableStep("details")
            }
        }

        if (designationType === "location"){
            if (locationId){
                setActiveStep("details")
                addAvailableStep("details")
            }
        }

        if (designationType === "user"){

            if (!currentUser.is_superuser){
                setUserId(currentUser.id)
            }

            if (userId){
                setActiveStep("details")
                addAvailableStep("details")
            }
        }

        // if (!currentUser.is_superuser){
        //     setUserId(currentUser.id)
        // }

    }, [warehouseId, sectionId, locationId, designationType, userId])

    return(
        <div className="new-items-request-container">

            {!hidePageHeadSection && <PageHeadSection pageName={itemsRequestApp.appName} />}

            <div className="new-items-requests-steps">
                <div className="steps-of-user-profile-page-container">
                    <div className="content-of-steps-of-user-profile-page-container">
                        {steps.map((step, index) => {

                            const returnClassName = (name: string) => {
                                if (hasStep(step.name)){
                                    return name
                                }

                                return name + " disabled"
                            }

                            return(
                                <div id={"step-" + step.name} onClick={() => {
                                    setActiveStep(step.name)
                                }} className={activateStep === step.name ? returnClassName("single-step-of-user-profile active") : returnClassName("single-step-of-user-profile")} key={index}>
                                    <div className="content-of-single-step-of-user-profile">
                                        <GenerateIcon icon={step.icon} />
                                        <p>{step.title}</p>
                                    </div>
                                </div>
                            )
                        })}
                        <div className="step-line" style={{ left: stepLineLeft, width: stepLineWidth }}></div>
                    </div>
                </div>

                <div className="active-step-content-container">
                    <div className="content-of-active-step-content-container">
                        {steps.map((step) => {
                            if (step.name === activateStep){
                                return step.component()
                            }

                            return <></>
                        })}
                    </div>
                </div>
            </div>

        </div>
    )
}